module.exports = __webpack_public_path__ + "img/PwIcon.31bb89b8.png";